import React, { useEffect, useState } from "react";
import autoRebook from "../../../controllers/booking/autoRebook";
import { useNavigate } from "react-router-dom";
import { formatMoney, getNumber } from "../../../features/utils/formatMoney";
import Button1 from "../../form/Button1";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { offerSearchTemp } from "../../../data/flight/offerSearchData";
import moment from "moment";
import { encrypt } from "../../../features/utils/crypto";
import { setBookingData } from "../../../redux/reducers/flight/flightBookingSlice";
import { useDispatch, useSelector } from "react-redux";

var cancelTokenSource = null;

export default function Rebook({ data, callback }) {
  const [loading, setLoading] = useState({ rebook: true });
  const [rebooking, setRebooking] = useState(false);
  const [priceChanged, setPriceChanged] = useState(false);

  const { bookingData } = useSelector((state) => state.flightBooking);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // console.log(data);
  useEffect(() => {
    if (data) handleAutoRebook({});
    //eslint-disable-next-line
  }, [data]);

  async function handleAutoRebook({ acceptPriceChange = false }) {
    const payload = {
      flightBookingId: data?._id,
      acceptPriceChange,
    };
    setRebooking(true);

    setLoading({ ...loading, rebook: true });
    // test cases
    // const res = await new Promise((resolve) => setTimeout(() => resolve({return: 0,msg: 'Failed',data: []}),2000))
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Request canceled.");
    }
    cancelTokenSource = axios.CancelToken.source();

    const res = await autoRebook(payload);
    setLoading({ ...loading, rebook: false });
    if (res.return) {
      setRebooking("success");
      if (res?.data?._id)
        navigate("/order/flight/ticket/detail/" + res?.data?._id);
      callback?.();
    } else if (res?.msg === "Price Changed") {
      // let data = (res.data?.map(obj => convertFlightObject(obj)) || [])
      setRebooking("price_change");
      let resData = [{ totalAmount: 1000000 }];
      setPriceChanged({
        price: resData?.at(0)?.totalAmount,
        change: resData?.at(0)?.totalAmount - getNumber(data?.payable),
      });
    } else setRebooking("failed");
  }

  function rebook(status) {
    const searchObj = {
      ...offerSearchTemp,
      originDestinations: data?.destinations?.map((obj, i) => ({
        from: obj?.from,
        to: obj?.to,
        departure: {
          date:
            status === "past_date"
              ? moment().add(i + 1, "days")
              : obj?.departureDate,
        },
        date:
          status === "past_date"
            ? moment().add(i + 1, "days")
            : obj?.departureDate,
      })),
      destinations: data?.destinations?.map((obj, i) => ({
        departureLocation: obj?.from,
        arrivalLocation: obj?.to,
        date:
          status === "past_date"
            ? moment().add(i + 1, "days")
            : obj?.departureDate,
      })),
      passengers: {
        adult: data?.adult?.passengerCount || undefined,
        child: data?.child?.passengerCount || undefined,
        infant: data?.infant?.passengerCount || undefined,
      },
      cabinClass: ["Economy"],
      // cabinClass: [...new Set(data?.flights?.map(obj => convertCabinName(obj?.cabinClass)))],
      flightFilters: {
        allowedCarriers: [
          ...new Set(data?.flights?.map((obj) => obj?.airline)),
        ],
      },
    };

    // search(obj)
    // return getPrice(searchObj)

    let enc = encrypt(JSON.stringify(searchObj));

    dispatch(
      setBookingData({
        ...bookingData,
        offer: null,
        time: null,
        travelers: data?.travelers,
      })
    );

    window.open(`/order/new/flight/offers?q=${enc}`, "_blank");
    setRebooking(false);
    // navigate(`/order/new/flight/offers?q=${enc}`);
  }

  console.log(loading);
  return (
    <div className="p-10 min-w-[300px]">
      {rebooking === "price_change" ? (
        <div>
          <div className="self-center max-w-[500px] ">
            <div className="card p-0 m-2 rounded-md flex flex-col">
              {/* <h4 className='py-2'>You have been gone for too long.</h4> */}
              <h5 className="py-2 self-center">Price Change</h5>
              {/* <p> The flight offer may have changed. Click the button to get the latest price.</p> */}
              <div className="text-primary/60">
                There has been a price change by :
                <b
                  className={`inline-block p-1 ${
                    priceChanged?.change < 0 ? "text-green-500" : "text-red-400"
                  }`}
                >
                  {priceChanged?.change < 0 ? "-" : "+"}{" "}
                  {formatMoney(Math.abs(priceChanged?.change))}
                </b>
              </div>
              <p>
                The updated price is{" "}
                <b className="font-bold text-primary">
                  {formatMoney(priceChanged?.price)}.
                </b>
              </p>
              <p>Do you want to continue or pick a different offer</p>
              <br />
              <div className="flex  flex-wrap justify-between gap-4">
                <Button1
                  className="!w-auto self-end"
                  variant="outlined"
                  onClick={() => navigate("/order/neworder")}
                >
                  <span className="hidden sm:inline-block pr-1">New</span> Offer
                </Button1>
                {/* <Button1 className='btn1 !w-auto self-end' onClick={() => (getPrice && getPrice()) || window.location.reload()}>Refresh</Button1> */}
                <Button1
                  loading={loading?.rebook === true}
                  className="btn1 !w-auto self-end"
                  onClick={() => handleAutoRebook({ acceptPriceChange: true })}
                >
                  Continue
                </Button1>
              </div>
            </div>
          </div>
        </div>
      ) : loading?.rebook ? (
        <div className="flex flex-col gap-4 justify-center items-center p-4">
          <CircularProgress />
          <p>Please hold on while we're rebooking your order.</p>
        </div>
      ) : rebooking === "success" ? (
        <div>
          <h5>Your order has been booked.</h5>
        </div>
      ) : (
        <div className="flex flex-col gap-6">
          <div>
            <h5>The offer is no longer available</h5>
            <p>
              Offer date has <label className="text-red-500">expired</label>.
              Please consider searching with a new date
            </p>
          </div>
          <div className="flex flex-wrap justify-between gap-4">
            <div>
              <Button1 variant={"outlined"} onClick={() => setRebooking(false)}>
                Cancel
              </Button1>
            </div>
            <div>
              <Button1 onClick={() => rebook("past_date")}>Search</Button1>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
